import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { GoogleOAuthProvider } from '@react-oauth/google';
import './i18n';

// local
// const clientId = '570639197039-morqeh69m91cp4m07lv4h795nvpt7fb5.apps.googleusercontent.com';

// https://salesroute-react-product.technaureus.com
const clientId = '327335530017-6ghcr7ed3u3ripst7bssh57f073u0dl0.apps.googleusercontent.com';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId={clientId}>
      <App />
    </GoogleOAuthProvider>
  </React.StrictMode>
);
reportWebVitals();

// import React from 'react';
// import ReactDOM from 'react-dom/client';
// import './index.css';
// import App from './App';
// import reportWebVitals from './reportWebVitals';
// import { GoogleOAuthProvider } from '@react-oauth/google';
// import { initPerfume } from 'perfume.js';

// // Local or production client ID
// // const clientId = '570639197039-morqeh69m91cp4m07lv4h795nvpt7fb5.apps.googleusercontent.com';
// const clientId = '366782435001-psi925bu8hm9d9lei875f6frh6pc1ou5.apps.googleusercontent.com';

// // Initialize Perfume.js
// initPerfume({
//   firstContentfulPaint: true,
//   largestContentfulPaint: true,
//   firstInputDelay: true,
//   cumulativeLayoutShift: true,
//   logging: true,
//   analyticsTracker: (metricName, data) => {
//     console.log(metricName, data);
//   }
// });

// const root = ReactDOM.createRoot(document.getElementById('root'));
// root.render(
//   <React.StrictMode>
//     <GoogleOAuthProvider clientId={clientId}>
//       <App />
//     </GoogleOAuthProvider>
//   </React.StrictMode>
// );

// reportWebVitals();
